import { useCallback } from 'react';
import { clearGuestSessionId, setTokens, useTokenRefresh } from '@/shared/lib';
import type { ClientProfileDto, TokenPairDto } from '@/app/store/api/restApi';
import { useApplyClientProfile, type AppliedClientProfileResult } from './useApplyClientProfile';

export type AuthPayload = {
  profile: ClientProfileDto;
  auth: TokenPairDto;
};

export type AppliedAuthResult = AppliedClientProfileResult;

export const useApplyAuthPayload = () => {
  const { scheduleRefreshTimer } = useTokenRefresh();
  const applyClientProfile = useApplyClientProfile();

  return useCallback(
    (payload: AuthPayload): AppliedAuthResult => {
      setTokens(payload.auth);
      scheduleRefreshTimer(payload.auth.expiresInSeconds);

      clearGuestSessionId();
      return applyClientProfile(payload.profile);
    },
    [applyClientProfile, scheduleRefreshTimer],
  );
};
